module.exports = __webpack_public_path__ + "f.no1.e554feb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/f.no1.jpg
// module id = wT3+
// module chunks = 0